(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-bundle-main"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.mk-bdl').forEach(function (root) {
  if (root.dataset.mkInit === '1') return;
  root.dataset.mkInit = '1';
  var track = root.querySelector('[data-mk-track]');
  if (!track) return;
  var slides = Array.prototype.slice.call(track.querySelectorAll('.mk-bdl__slide'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('.mk-bdl__thumb'));
  var prev = root.querySelector('.mk-bdl__arrow--prev');
  var next = root.querySelector('.mk-bdl__arrow--next');
  if (slides.length < 2) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var idx = 0;
  var target = -1;
  var unlock = null;

  /* Slides after the first keep their image in data-* until needed, so they never
     compete with the first image while the page loads. */
  function hydrate(slide) {
    var img = slide && slide.querySelector('img[data-srcset]');
    if (!img) return;
    img.setAttribute('srcset', img.getAttribute('data-srcset'));
    img.setAttribute('src', img.getAttribute('data-src'));
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
  }

  function mark(n) {
    if (n < 0 || n === idx) return;
    idx = n;
    thumbs.forEach(function (b, i) {
      b.classList.toggle('is-active', i === n);
      b.setAttribute('aria-current', i === n ? 'true' : 'false');
    });
    hydrate(slides[n + 1]);
  }

  /* Arrows and thumbs: the thumb lights up at once, the image glides over natively. */
  function go(n) {
    n = (n + slides.length) % slides.length;
    hydrate(slides[n]);
    target = n;
    clearTimeout(unlock);
    unlock = setTimeout(function () { target = -1; }, 900);
    track.scrollTo({ left: slides[n].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    mark(n);
  }

  /* Swipes: the browser scrolls (smooth, off the main thread); this only keeps the
     thumbs in step and loads the next image ahead. */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting || e.intersectionRatio <= 0) return;
        hydrate(e.target);
        var i = slides.indexOf(e.target);
        if (e.intersectionRatio >= 0.6 && (target === -1 || i === target)) mark(i);
      });
    }, { root: track, threshold: [0.01, 0.6] });
    slides.forEach(function (s) { io.observe(s); });
  } else {
    slides.forEach(hydrate);
  }

  /* Once the page has loaded, fetch the rest quietly so every swipe is instant. */
  function warm() { slides.forEach(hydrate); }
  function afterLoad() { (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(warm); }
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad, { once: true });

  thumbs.forEach(function (b, n) { b.addEventListener('click', function () { go(n); }); });
  if (prev) prev.addEventListener('click', function () { go(idx - 1); });
  if (next) next.addEventListener('click', function () { go(idx + 1); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__mkCartEnhanced) return;
  window.__mkCartEnhanced = true;

  function root() { return document.querySelector('.mk-basket'); }
  function wrap() { var r = root(); return r ? r.closest('.shopify-section') : null; }

  function rerender(sectionsJson, sectionId) {
    var w = wrap();
    if (w && sectionsJson && sectionsJson[sectionId] != null) {
      var tmp = document.createElement('div');
      tmp.innerHTML = sectionsJson[sectionId];
      var fresh = tmp.querySelector('.mk-basket');
      var current = root();
      if (fresh && current) { current.replaceWith(fresh); return true; }
    }
    return false;
  }

  // Shopify said no (sold out, say): its message goes on the line, and nothing changes.
  function fail(el, message) {
    var r = root(); if (r) r.classList.remove('is-busy');
    var item = el && el.closest ? el.closest('.mk-basket__item') : null;
    var body = item ? item.querySelector('.mk-basket__body') : null;
    if (!body) { window.location.reload(); return; }
    var p = body.querySelector('.mk-basket__adderr');
    if (!p) {
      p = document.createElement('p');
      p.className = 'mk-basket__adderr';
      p.setAttribute('role', 'alert');
      body.appendChild(p);
    }
    p.textContent = message || 'That didn’t work. Please try again.';
  }

  // One Cart API call, then the section is redrawn from the same response.
  function post(url, payload, el) {
    var r = root(); if (!r) return;
    var sectionId = r.getAttribute('data-section-id');
    payload.sections = sectionId;
    r.classList.add('is-busy');
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (out) {
        if (!out.ok) { fail(el, out.data && (out.data.description || out.data.message)); return; }
        if (!rerender(out.data.sections, sectionId)) window.location.reload();
      })
      .catch(function () { window.location.reload(); });
  }

  // Lines are changed by their key, never by position: the page draws a book's
  // extras under it, which isn't always the basket's own order.
  function setQty(key, quantity, el) { post('/cart/change.js', { id: key, quantity: quantity }, el); }

  function removeKeys(keys, el) {
    var updates = {};
    keys.forEach(function (k) { if (k) updates[k] = 0; });
    post('/cart/update.js', { updates: updates }, el);
  }

  function addLine(variantId, properties, el) {
    var line = { id: Number(variantId), quantity: 1 };
    if (properties) line.properties = properties;
    post('/cart/add.js', { items: [line] }, el);
  }

  function nextQty(qwrap, wanted) {
    var max = parseInt(qwrap.getAttribute('data-max'), 10);
    var next = Math.max(0, wanted);
    return max > 0 ? Math.min(next, max) : next;
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var qbtn = e.target.closest('.mk-basket__qbtn');
    if (qbtn) {
      var qwrap = qbtn.closest('.mk-basket__qty');
      var input = qwrap.querySelector('.mk-basket__qinput');
      var current = parseInt(input.value, 10) || 0;
      var next = nextQty(qwrap, current + parseInt(qbtn.getAttribute('data-qty-change'), 10));
      if (next !== current) setQty(qwrap.getAttribute('data-key'), next, qbtn);
      return;
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) { removeKeys((rm.getAttribute('data-remove') || '').split(','), rm); return; }
    var addon = e.target.closest('[data-addon]');
    if (addon) {
      var props = null;
      try { props = JSON.parse(addon.getAttribute('data-props') || 'null'); } catch (err) { props = null; }
      addLine(addon.getAttribute('data-addon'), props, addon);
      return;
    }
    var addBtn = e.target.closest('[data-add-id]');
    if (addBtn) { addLine(addBtn.getAttribute('data-add-id'), null, addBtn); return; }
    var copyBtn = e.target.closest('[data-promo-copy]');
    if (copyBtn) { copyCode(copyBtn); return; }
    var promo = e.target.closest('[data-promo]');
    if (promo) {
      var inp = document.querySelector('.mk-basket__promoinput');
      var code = inp ? inp.value.trim() : '';
      if (code) {
        try { sessionStorage.setItem('mk_promo_try', code); } catch (err) {}
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
      }
      return;
    }
  });

  // GIFT CARDS AND CODES THAT DIDN'T TAKE. Shopify applies gift cards only at
  // checkout, so after Apply the cart checks the code against the ones that
  // applied (data-applied, from Liquid) and says what to do.
  function promoEls() {
    return { box: document.querySelector('.mk-basket__promo'), msg: document.querySelector('[data-promo-msg]') };
  }
  function looksLikeGiftCard(code) { return /^[a-z0-9]{16}$/i.test(code.replace(/[\s-]/g, '')); }
  function say(msg, parts) {
    msg.textContent = '';
    parts.forEach(function (p) {
      if (typeof p === 'string') { msg.appendChild(document.createTextNode(p)); return; }
      var el = document.createElement(p.tag);
      el.textContent = p.text;
      if (p.cls) el.className = p.cls;
      if (p.attrs) Object.keys(p.attrs).forEach(function (k) { el.setAttribute(k, p.attrs[k]); });
      msg.appendChild(el);
    });
    msg.hidden = false;
  }
  function copyCode(btn) {
    var code = btn.getAttribute('data-promo-copy') || '';
    var done = function () { btn.textContent = 'Copied'; };
    var fallback = function () {
      var inp = document.querySelector('.mk-basket__promoinput');
      if (inp) { inp.value = code; inp.focus(); inp.select(); }
    };
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, fallback);
      else fallback();
    } catch (err) { fallback(); }
  }
  function checkPromo() {
    var tried = null;
    try { tried = sessionStorage.getItem('mk_promo_try'); sessionStorage.removeItem('mk_promo_try'); } catch (err) {}
    var els = promoEls();
    if (!tried || !els.box || !els.msg) return;
    var applied = (els.box.getAttribute('data-applied') || '').split('|').filter(Boolean);
    var took = applied.some(function (c) { return c.toLowerCase() === tried.toLowerCase(); });
    els.msg.classList.toggle('is-ok', took);
    if (took) { say(els.msg, ['\u201c', { tag: 'strong', text: tried }, '\u201d applied.']); return; }
    var inp = document.querySelector('.mk-basket__promoinput');
    if (inp) inp.value = tried;
    // Clear the code that didn't take, so checkout doesn't open on a warning about it.
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: applied.join(',') })
    }).catch(function () {});
    if (looksLikeGiftCard(tried)) {
      var clean = tried.replace(/[\s-]/g, '');
      say(els.msg, [
        { tag: 'strong', text: 'That looks like a gift card.' },
        ' Gift cards are added at checkout: paste it into the \u201cDiscount code or gift card\u201d box and it comes off your total there. ',
        { tag: 'button', text: 'Copy code', cls: 'mk-basket__promocopy', attrs: { type: 'button', 'data-promo-copy': clean } }
      ]);
    } else {
      say(els.msg, [
        'We couldn\u2019t apply \u201c', { tag: 'strong', text: tried }, '\u201d. Check the code, or if it\u2019s a gift card, add it at checkout in the \u201cDiscount code or gift card\u201d box. ',
        { tag: 'button', text: 'Copy code', cls: 'mk-basket__promocopy', attrs: { type: 'button', 'data-promo-copy': tried } }
      ]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', checkPromo);
  else checkPromo();

  document.addEventListener('change', function (e) {
    var input = e.target.closest ? e.target.closest('.mk-basket__qinput') : null;
    if (!input) return;
    var qwrap = input.closest('.mk-basket__qty');
    setQty(qwrap.getAttribute('data-key'), nextQty(qwrap, parseInt(input.value, 10) || 0), input);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-collection-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__mkccEnhanced) return;
  var grid = document.querySelector('.mk-cc');
  if (!grid) return;
  var gridWrap = grid.closest('.shopify-section');
  if (!gridWrap) return;
  window.__mkccEnhanced = true;
  var gridId = gridWrap.id.replace('shopify-section-', '');

  function filtersWrap() {
    var f = document.querySelector('.mk-filters');
    return f ? f.closest('.shopify-section') : null;
  }

  function update(url, push, scrollUp) {
    var fw = filtersWrap();
    var fid = fw ? fw.id.replace('shopify-section-', '') : null;
    var ids = fid ? gridId + ',' + fid : gridId;
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    gridWrap.classList.add('mk-cc-loading');
    fetch(url + sep + 'sections=' + ids)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data[gridId] != null) gridWrap.innerHTML = data[gridId];
        if (fw && fid && data[fid] != null) fw.innerHTML = data[fid];
        gridWrap.classList.remove('mk-cc-loading');
        if (push) window.history.pushState({ mkcc: 1 }, '', url);
        if (scrollUp) {
          var anchor = filtersWrap() || gridWrap;
          window.scrollTo({ top: anchor.getBoundingClientRect().top + window.pageYOffset - 16, behavior: 'smooth' });
        }
      })
      .catch(function () { window.location.href = url; });
  }

  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('.mk-filters__pill, .mk-filters__clear, .mk-filters__sortmenu a, a.mk-cc__pg');
    if (!a || !a.href) return;
    e.preventDefault();
    update(a.href, true, a.classList.contains('mk-cc__pg'));
  });

  window.addEventListener('popstate', function () { update(window.location.href, false, false); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  // The header bar's height, for anything that sticks just under it (the
  // collection's filter bar): --mk-header-h on the page.
  var bar = document.querySelector('.mk-headerwrap .mk-header');
  function headerHeight() {
    if (bar) document.documentElement.style.setProperty('--mk-header-h', Math.round(bar.getBoundingClientRect().height) + 'px');
  }
  headerHeight();
  window.addEventListener('resize', headerHeight);

  // Announcement strip: each half of the track is at least as wide as the
  // screen (messages repeat as needed), so the loop never shows a gap, and it
  // moves at the same speed however many messages there are.
  document.querySelectorAll('.mk-strip').forEach(function (strip) {
    var track = strip.querySelector('.mk-strip__track');
    var sets = strip.querySelectorAll('.mk-strip__set');
    if (!track || sets.length < 2) return;
    var original = sets[0].innerHTML;
    var speed = parseInt(strip.getAttribute('data-speed'), 10) || 40;
    function fit() {
      sets[0].innerHTML = original;
      var guard = 0;
      while (sets[0].scrollWidth < strip.clientWidth && guard++ < 12) sets[0].insertAdjacentHTML('beforeend', original);
      sets[1].innerHTML = sets[0].innerHTML;
      track.style.setProperty('--mk-strip-dur', Math.max(8, sets[0].scrollWidth / speed) + 's');
    }
    fit();
    var w = strip.clientWidth;
    window.addEventListener('resize', function () { if (Math.abs(strip.clientWidth - w) > 40) { w = strip.clientWidth; fit(); } });
  });

  // Desktop panels: open on hover (with a short grace period, so the pointer
  // can travel from the word to the panel), on focus, and on tap for touch
  // screens; close on Escape, on leaving, or when another opens.
  var items = Array.prototype.slice.call(document.querySelectorAll('.mk-hasdrop'));
  var quiet = false;
  function setOpen(item, open) {
    var trigger = item.querySelector('.mk-nav__link');
    if (open) {
      items.forEach(function (o) { if (o !== item) setOpen(o, false); });
      item.setAttribute('data-open', '');
    } else {
      item.removeAttribute('data-open');
    }
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  items.forEach(function (item) {
    var timer = null;
    var trigger = item.querySelector('.mk-nav__link');
    item.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch') return;
      clearTimeout(timer);
      setOpen(item, true);
    });
    item.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch') return;
      clearTimeout(timer);
      timer = setTimeout(function () { setOpen(item, false); }, 180);
    });
    item.addEventListener('focusin', function () { if (!quiet) setOpen(item, true); });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) setOpen(item, false);
    });
    if (trigger) {
      // A tap opens the panel first; a second tap follows the link.
      trigger.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: none)').matches && !item.hasAttribute('data-open')) {
          e.preventDefault();
          setOpen(item, true);
        }
      });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    items.forEach(function (item) {
      if (item.hasAttribute('data-open')) {
        setOpen(item, false);
        var t = item.querySelector('.mk-nav__link');
        quiet = true;
        if (t) t.focus();
        quiet = false;
      }
    });
  });
  document.addEventListener('click', function (e) {
    items.forEach(function (item) { if (!item.contains(e.target)) setOpen(item, false); });
  });

  // Mobile drawer: fills the screen below the header and stops the page behind it scrolling.
  document.querySelectorAll('.mk-burger').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var wrap = btn.closest('.mk-headerwrap');
    if (!panel || !wrap) return;
    var label = btn.querySelector('.mk-burger__label');
    function close() {
      panel.removeAttribute('data-open');
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Open menu');
      if (label) label.textContent = 'Menu';
      document.documentElement.style.overflow = '';
    }
    btn.addEventListener('click', function () {
      if (panel.hasAttribute('data-open')) { close(); return; }
      var bar = wrap.querySelector('.mk-header');
      var bottom = bar ? bar.getBoundingClientRect().bottom : 112;
      wrap.style.setProperty('--mk-head-h', Math.max(0, Math.round(bottom)) + 'px');
      panel.setAttribute('data-open', '');
      btn.setAttribute('aria-expanded', 'true');
      btn.setAttribute('aria-label', 'Close menu');
      if (label) label.textContent = 'Close';
      document.documentElement.style.overflow = 'hidden';
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.hasAttribute('data-open')) { close(); btn.focus(); } });
    window.addEventListener('resize', function () { if (window.innerWidth > 900 && panel.hasAttribute('data-open')) close(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-peek"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.mk-peek__stage').forEach(function (stage) {
    var slides = Array.prototype.slice.call(stage.querySelectorAll('.mk-peek__slide'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(stage.querySelectorAll('.mk-peek__dot'));
    var i = 0, timer = null;
    var interval = (parseInt(stage.dataset.interval, 10) || 4) * 1000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(n) {
      slides[i].removeAttribute('data-active');
      if (dots[i]) dots[i].removeAttribute('data-active');
      i = (n + slides.length) % slides.length;
      slides[i].setAttribute('data-active', '');
      if (dots[i]) dots[i].setAttribute('data-active', '');
    }
    function start() { if (reduce) return; stop(); timer = setInterval(function () { go(i + 1); }, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    var prev = stage.querySelector('.mk-peek__prev');
    var next = stage.querySelector('.mk-peek__next');
    if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
    if (next) next.addEventListener('click', function () { go(i + 1); start(); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); start(); }); });

    stage.addEventListener('mouseenter', stop);
    stage.addEventListener('mouseleave', start);

    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      x0 = null; start();
    }, { passive: true });

    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-product-main"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.mk-pdp').forEach(function (root) {
  if (root.dataset.mkInit === '1') return;
  root.dataset.mkInit = '1';
  var track = root.querySelector('[data-mk-track]');
  if (!track) return;
  var slides = Array.prototype.slice.call(track.querySelectorAll('.mk-pdp__slide'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('.mk-pdp__thumb'));
  var prev = root.querySelector('.mk-pdp__arrow--prev');
  var next = root.querySelector('.mk-pdp__arrow--next');
  if (slides.length < 2) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var idx = 0;
  var target = -1;
  var unlock = null;

  /* Slides after the first keep their image in data-* until needed, so they never
     compete with the first image while the page loads. */
  function hydrate(slide) {
    var img = slide && slide.querySelector('img[data-srcset]');
    if (!img) return;
    img.setAttribute('srcset', img.getAttribute('data-srcset'));
    img.setAttribute('src', img.getAttribute('data-src'));
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
  }

  function mark(n) {
    if (n < 0 || n === idx) return;
    idx = n;
    thumbs.forEach(function (b, i) {
      b.classList.toggle('is-active', i === n);
      b.setAttribute('aria-current', i === n ? 'true' : 'false');
    });
    hydrate(slides[n + 1]);
  }

  /* Arrows and thumbs: the thumb lights up at once, the image glides over natively. */
  function go(n) {
    n = (n + slides.length) % slides.length;
    hydrate(slides[n]);
    target = n;
    clearTimeout(unlock);
    unlock = setTimeout(function () { target = -1; }, 900);
    track.scrollTo({ left: slides[n].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    mark(n);
  }

  /* Swipes: the browser scrolls (smooth, off the main thread); this only keeps the
     thumbs in step and loads the next image ahead. */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting || e.intersectionRatio <= 0) return;
        hydrate(e.target);
        var i = slides.indexOf(e.target);
        if (e.intersectionRatio >= 0.6 && (target === -1 || i === target)) mark(i);
      });
    }, { root: track, threshold: [0.01, 0.6] });
    slides.forEach(function (s) { io.observe(s); });
  } else {
    slides.forEach(hydrate);
  }

  /* Once the page has loaded, fetch the rest quietly so every swipe is instant. */
  function warm() { slides.forEach(hydrate); }
  function afterLoad() { (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(warm); }
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad, { once: true });

  thumbs.forEach(function (b, n) { b.addEventListener('click', function () { go(n); }); });
  if (prev) prev.addEventListener('click', function () { go(idx - 1); });
  if (next) next.addEventListener('click', function () { go(idx + 1); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-product-preview"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.mk-preview__stage').forEach(function (stage) {
    var url = stage.dataset.pdf;
    if (!url) return;
    var frame = stage.querySelector('.mk-preview__frame');
    var canvas = stage.querySelector('.mk-preview__canvas');
    var track = stage.querySelector('.mk-preview__track');
    var counter = stage.querySelector('.mk-preview__counter');
    var prevBtn = stage.querySelector('.mk-preview__prev');
    var nextBtn = stage.querySelector('.mk-preview__next');
    var loading = stage.querySelector('.mk-preview__loading');
    if (!frame || !canvas || !track) return;

    var coverPages = parseInt(stage.dataset.coverPages, 10) || 1;
    var backPages = parseInt(stage.dataset.backPages, 10) || 1;

    var pdfDoc = null, total = 0, pageRatio = 1, bookHeight = 0, border = 0;
    var views = [], hasSpread = false, current = 0;
    var busy = false, queued = null, started = false;

    function buildViews() {
      views = [];
      if (total <= coverPages + backPages) {
        for (var i = 1; i <= total; i++) views.push([i]);
      } else {
        for (var a = 1; a <= coverPages; a++) views.push([a]);
        var start = coverPages + 1, end = total - backPages, j = start;
        while (j <= end) {
          if (j + 1 <= end) { views.push([j, j + 1]); j += 2; }
          else { views.push([j]); j += 1; }
        }
        for (var b = total - backPages + 1; b <= total; b++) views.push([b]);
      }
      hasSpread = views.some(function (v) { return v.length === 2; });
    }

    function computeLayout() {
      var aw = stage.clientWidth || 600;
      border = parseFloat(getComputedStyle(frame).borderLeftWidth) || 0;
      var inner = aw - (2 * border);
      var widest = hasSpread ? (2 * pageRatio) : pageRatio;
      bookHeight = inner / widest;
      track.style.aspectRatio = 'auto';
      track.style.height = bookHeight + 'px';
    }

    function updateControls() {
      if (prevBtn) prevBtn.disabled = current <= 0;
      if (nextBtn) nextBtn.disabled = current >= views.length - 1;
      if (counter) {
        var v = views[current];
        counter.textContent = v.length === 1
          ? 'Page ' + v[0] + ' of ' + total
          : 'Pages ' + v[0] + '-' + v[1] + ' of ' + total;
      }
    }

    function renderPage(pageNum, h, dpr) {
      return pdfDoc.getPage(pageNum).then(function (page) {
        var base = page.getViewport({ scale: 1 });
        var scale = (h * dpr) / base.height;
        var vp = page.getViewport({ scale: scale });
        var off = document.createElement('canvas');
        off.width = Math.round(vp.width);
        off.height = Math.round(vp.height);
        return page.render({ canvasContext: off.getContext('2d'), viewport: vp }).promise.then(function () { return off; });
      });
    }

    function blit(parts, h, dpr) {
      var totalW = 0;
      parts.forEach(function (c) { totalW += c.width; });
      canvas.width = totalW;
      canvas.height = Math.round(h * dpr);
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var x = 0;
      parts.forEach(function (c) { ctx.drawImage(c, x, 0); x += c.width; });
      var cssW = totalW / dpr;
      frame.style.width = (cssW + (2 * border)) + 'px';
      canvas.classList.add('is-ready');
      if (loading) loading.classList.add('is-hidden');
    }

    function drawView(idx) {
      var v = views[idx];
      var h = bookHeight;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var jobs = v.map(function (n) { return renderPage(n, h, dpr); });
      return Promise.all(jobs).then(function (parts) { blit(parts, h, dpr); });
    }

    function afterDraw() {
      busy = false;
      if (queued !== null) { var q = queued; queued = null; requestView(q); }
    }

    function requestView(idx) {
      current = Math.max(0, Math.min(views.length - 1, idx));
      updateControls();
      if (busy) { queued = current; return; }
      busy = true;
      drawView(current).then(afterDraw).catch(afterDraw);
    }

    function boot() {
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = stage.dataset.pdfworker;
      window.pdfjsLib.getDocument(url).promise.then(function (pdf) {
        pdfDoc = pdf;
        total = pdf.numPages;
        return pdf.getPage(1);
      }).then(function (page) {
        var base = page.getViewport({ scale: 1 });
        pageRatio = base.width / base.height;
        buildViews();
        computeLayout();
        requestView(0);
      }).catch(function () {
        if (loading) loading.classList.add('is-hidden');
        if (counter) counter.textContent = '';
      });
    }

    function loadLib(cb) {
      if (window.pdfjsLib) { cb(); return; }
      var existing = document.querySelector('script[data-mk-pdfjs]');
      if (existing) { existing.addEventListener('load', cb); return; }
      var sc = document.createElement('script');
      sc.src = stage.dataset.pdfjs;
      sc.setAttribute('data-mk-pdfjs', '1');
      sc.addEventListener('load', function () { if (window.pdfjsLib) cb(); });
      document.head.appendChild(sc);
    }

    function start() { if (started) return; started = true; loadLib(boot); }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); start(); } });
      }, { rootMargin: '300px' });
      io.observe(stage);
    } else {
      start();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { requestView(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { requestView(current + 1); });

    var rt = null;
    window.addEventListener('resize', function () {
      if (rt) clearTimeout(rt);
      rt = setTimeout(function () { if (pdfDoc) { computeLayout(); requestView(current); } }, 200);
    });

    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) requestView(dx < 0 ? current + 1 : current - 1);
      x0 = null;
    }, { passive: true });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
